import { useNavigate } from 'react-router-dom';
import { ReactComponent as Check } from '../../../../assets/images/icon/check.svg'
import { SolidBtn } from '../../../../shared'
import { useEffect, useState } from 'react';
import { useCreateCommunityPolicyByCommunityPolicyCreateWebRequest, useGetCommunityPolicyIsCommunityPolicyChecked } from './model';

const CommunityPolicyBanner = () => {
    const navigate = useNavigate();
    const [isValidate, setIsValidate] = useState<boolean>(true);
    const { data, isSuccess } = useGetCommunityPolicyIsCommunityPolicyChecked();
    const createCommunityPolicyByCommunityPolicyCreateWebRequest = useCreateCommunityPolicyByCommunityPolicyCreateWebRequest();

    const onClickConfirm = () => {
        const communityPolicyCreateWebRequest: ICommunityPolicyCreateWebRequest = { isCommunityPolicyChecked: true }

        createCommunityPolicyByCommunityPolicyCreateWebRequest.mutate(communityPolicyCreateWebRequest,
            {
                onSuccess: () => setIsValidate(true)
            })

    }

    useEffect(() => {
        if (!isSuccess) return;
        setIsValidate(data);
    }, [isSuccess, data])

    return <>
        {!isValidate &&
            <div style={{ paddingInline: '20px', marginBottom: '24px' }}>
                <div style={{ padding: '12px 12px 16px', backgroundColor: 'var(--secondarys100)', borderRadius: '4px' }}>
                    <div className="title/t1" style={{ marginBottom: '8px' }}>
                        커뮤니티에 오신 걸 환영합니다!
                    </div>
                    <div className="body/b2 secondary/s850" style={{ marginBottom: '12px' }}>
                        요가와 웰니스, 일상 속 회복을 함께 나눠요.<br />
                        모두가 편안하게 이야기 나눌 수 있도록 <span onClick={() => navigate('/communityPolicy')} style={{ textDecorationLine: 'underline', textUnderlineOffset: '16%' }}>운영 정책</span>을 확인해주세요.
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
                        <Check width={16} height={16} stroke='var(--secondarys500)' />
                        <div className='body/b2 secondary/s850'>
                            존중하는 말과 태도로 이야기해요.
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '16px' }}>
                        <Check width={16} height={16} stroke='var(--secondarys500)' />
                        <div className='body/b2 secondary/s850'>
                            광고, 욕설, 혐오표현, 저작권침해는 제재될 수 있어요.
                        </div>
                    </div>
                    <SolidBtn onClick={onClickConfirm} type='line' icon={false} children='확인' styles={{ container: { backgroundColor: 'transparent', border: '1px solid var(--secondarys400, #AEAEAE)', borderRadius: '2px', paddingBlock: '8px' }, children: { color: 'var(--secondarys600)' } }} />
                </div>

            </div>}
    </>
}

export default CommunityPolicyBanner